// import { useEffect } from 'react'
// import { X } from 'lucide-react'
//
// export const Modal = ({ isOpen, onClose, title, children, size = 'md' }) => {
//   useEffect(() => {
//     if (isOpen) {
//       document.body.style.overflow = 'hidden'
//     }
//     return () => {
//       document.body.style.overflow = 'unset'
//     }
//   }, [isOpen])
//
//   if (!isOpen) return null
//
//   const sizes = {
//     sm: 'max-w-sm',
//     md: 'max-w-md',
//     lg: 'max-w-lg',
//     xl: 'max-w-xl',
//     '2xl': 'max-w-2xl',
//   }
//
//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className={`bg-white rounded-lg shadow-xl ${sizes[size]} w-full mx-4`}>
//         <div className="flex items-center justify-between p-6 border-b">
//           <h2 className="text-xl font-bold">{title}</h2>
//           <button
//             onClick={onClose}
//             className="text-gray-500 hover:text-gray-700"
//           >
//             <X size={24} />
//           </button>
//         </div>
//         <div className="p-6">
//           {children}
//         </div>
//       </div>
//     </div>
//   )
// }

import { useEffect } from 'react'
import { X } from 'lucide-react'

export const Modal = ({ isOpen, onClose, title, children, size = 'md' }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  if (!isOpen) return null

  const sizes = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div
        className={`bg-white rounded-lg shadow-xl ${sizes[size]} w-full max-h-[90vh] overflow-y-auto`}
      >
        <div className="flex items-center justify-between p-4 md:p-6 border-b sticky top-0 bg-white">
          <h2 className="text-lg md:text-xl font-bold truncate">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 flex-shrink-0 ml-4"
          >
            <X size={24} />
          </button>
        </div>
        <div className="p-4 md:p-6">
          {children}
        </div>
      </div>
    </div>
  )
}
